import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

// Placeholder image - à remplacer par les vraies photos plus tard
const restaurantImage = '/images/restaurant.jpg';

const RestaurantSection = styled.section`
  padding: ${({ theme }) => theme.spacing.xxl} 0;
  background-color: ${({ theme }) => theme.colors.light};
`;

const RestaurantContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.md};
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  position: relative;
  padding-bottom: ${({ theme }) => theme.spacing.md};
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;

const RestaurantContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.xl};
  align-items: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const RestaurantImage = styled.div`
  height: 400px;
  background-image: url(${restaurantImage});
  background-size: cover;
  background-position: center;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 300px;
    order: 1;
  }
`;

const RestaurantInfo = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    order: 2;
  }
`;

const RestaurantDescription = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  font-size: 1.1rem;
  line-height: 1.6;
`;

const MenuPreview = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.lg};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const MenuTitle = styled.h3`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.3rem;
  position: relative;
  padding-bottom: ${({ theme }) => theme.spacing.xs};
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;


const RestaurantButton = styled(Link)`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-weight: 600;
  text-decoration: none;
  transition: background-color ${({ theme }) => theme.transitions.fast};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

const RestaurantPreview = () => {
  const { t, language } = useLanguage();
  return (
    <RestaurantSection>
      <RestaurantContainer>
        <SectionTitle>{t('restaurant.preview.title')}</SectionTitle>
        <RestaurantContent>
          <RestaurantInfo>            
            <MenuPreview>
              <MenuTitle>{t('restaurant.preview.cuisine')}</MenuTitle>
              <RestaurantDescription>
                {t('restaurant.preview.description1')}
              </RestaurantDescription>
            </MenuPreview>
            
            <RestaurantButton to={`/${language}/restaurant`}>{t('restaurant.preview.button')}</RestaurantButton>
          </RestaurantInfo>
          
          <RestaurantImage />
        </RestaurantContent>
      </RestaurantContainer>
    </RestaurantSection>
  );
};

export default RestaurantPreview;
